module.exports = __webpack_public_path__ + "img/part4.eaa73775.png";